<template>
    <div/>
</template>

<script>
    export default {
        name: "LogOut",
        async mounted(){
            this.$store.dispatch('logout').then(()=>{
                this.$router.push({
                    name: 'Login'
                })
            })
        }
    }
</script>

<style scoped>

</style>
